var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 0H0.8C0.358167 0 0 0.358167 0 0.8V11.4667C0 11.9085 0.358167 12.2667 0.8 12.2667H5.57333L5.36 14.4H4.53333C4.38607 14.4 4.26667 14.5194 4.26667 14.6667V15.4667H3.73333V16H12.2667V15.4667H11.7333V14.6667C11.7333 14.5194 11.6139 14.4 11.4667 14.4H10.6413L10.428 12.2667H15.2C15.6418 12.2667 16 11.9085 16 11.4667V0.8C16 0.358167 15.6418 0 15.2 0ZM11.2 14.9333V15.4667H4.8V14.9333H11.2ZM5.89467 14.4L6.108 12.2667H9.89333L10.1067 14.4H5.89467ZM15.4667 11.4667C15.4667 11.6139 15.3473 11.7333 15.2 11.7333H0.8C0.652733 11.7333 0.533333 11.6139 0.533333 11.4667V0.8C0.533333 0.652733 0.652733 0.533333 0.8 0.533333H15.2C15.3473 0.533333 15.4667 0.652733 15.4667 0.8V11.4667Z",
    fill: "#6A69E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3997 1.06689H1.59974C1.30517 1.06689 1.06641 1.30566 1.06641 1.60023V9.86689C1.06641 10.0142 1.18581 10.1336 1.33307 10.1336H14.6664C14.8137 10.1336 14.9331 10.0142 14.9331 9.86689V1.60023C14.9331 1.30566 14.6943 1.06689 14.3997 1.06689ZM14.3997 9.60023H1.59974V1.60023H14.3997V9.60023Z",
    fill: "#6A69E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.26575 10.667H7.73242V11.2003H8.26575V10.667Z",
    fill: "#6A69E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41094 5.41179L8.26614 6.55659V2.66699H7.7328V6.55659L6.588 5.41179L6.21094 5.78886L7.81094 7.38886C7.86094 7.43886 7.92874 7.46699 7.99947 7.46699C8.0702 7.46699 8.138 7.43886 8.188 7.38886L9.788 5.78886L9.41094 5.41179Z",
    fill: "#6A69E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.134 7.7334V8.00007H5.86732V7.7334H5.33398V8.26673C5.33398 8.414 5.45338 8.5334 5.60065 8.5334H10.4007C10.5479 8.5334 10.6673 8.414 10.6673 8.26673V7.7334H10.134Z",
    fill: "#6A69E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.a813337e2831a5de8195bee74eea086a.svg";
export { ForwardRef as ReactComponent };